var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiukit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 898,
    height: 223,
    viewBox: "0 0 898 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.420456 219V0.818175H26.8409V195.562H128.261V219H0.420456ZM195.591 0.818175V219H169.17V0.818175H195.591ZM391.747 0.818175H418.167V145.278C418.167 160.193 414.652 173.51 407.62 185.229C400.66 196.876 390.824 206.074 378.11 212.821C365.397 219.497 350.483 222.835 333.366 222.835C316.25 222.835 301.335 219.497 288.622 212.821C275.909 206.074 266.037 196.876 259.005 185.229C252.045 173.51 248.565 160.193 248.565 145.278V0.818175H274.985V143.148C274.985 153.801 277.329 163.283 282.017 171.592C286.704 179.831 293.38 186.33 302.045 191.088C310.781 195.776 321.221 198.119 333.366 198.119C345.511 198.119 355.951 195.776 364.687 191.088C373.423 186.33 380.099 179.831 384.716 171.592C389.403 163.283 391.747 153.801 391.747 143.148V0.818175Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M470.928 219V0.818175H497.349V109.057H499.906L597.917 0.818175H632.434L540.815 99.2557L632.434 219H600.474L524.621 117.58L497.349 148.261V219H470.928ZM693.052 0.818175V219H666.631V0.818175H693.052ZM734.094 24.2557V0.818175H897.73V24.2557H829.123V219H802.702V24.2557H734.094Z",
    fill: "url(#paint0_linear_3_22)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_22",
    x1: 443.5,
    y1: -72,
    x2: 443.5,
    y2: 291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dc2626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc2626"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiukit);
export default __webpack_public_path__ + "static/media/LIUKIT.beb32be90f90d8b4590a1c4a70ad4f2a.svg";
export { ForwardRef as ReactComponent };